import { IconClap } from '@doltech/icons-from-dev/IconClap';
import { IconInterfaceEssentialBack } from '@doltech/icons-from-dev/IconInterfaceEssentialBack';
import { IconBrandsFacebook } from '@doltech/icons/IconBrandsFacebook';
import { IconMultimediaPlayButtonO } from '@doltech/icons/IconMultimediaPlayButtonO';
import { PageTypeEnum } from '@doltech/utils/lib/constants';
import { getLandingUrlFromPath } from '@doltech/utils/lib/url';
import cl from 'classnames';
import { uniq } from 'lodash';
import * as React from 'react';
import styled from 'styled-components';

import { useHistoryRouter } from '../../../../hooks/useHistoryRouter';
import { BlogSocialButtonProps } from '../../../Blog/BlogLayout';
import { Button } from '../../../ButtonV2/ButtonV2';
import { Link } from '../../../Link';
// import { PageClapButton } from '../../../PageClapButton/PageClapButton';
import { DolFacebookShareButton } from '../../../Social/DolFacebookShareButton';
import { CopyLinkButton } from './CopyLinkButton';

const Main = styled.div.withConfig({
  componentId: 'BlogSocialButton_Main',
} as any)`
  &.horizontal {
    display: grid;
    grid-auto-flow: column;
    gap: 16px;
    justify-content: flex-start;
    > .copy-link-btn-tooltip {
      height: 100%;
      display: grid;
      .icon {
        line-height: inherit;
      }
    }
  }
  &.vertical {
    display: grid;
    gap: 16px;
  }
  &.hide-text {
    .text {
      display: none;
    }
  }
`;

export const SocialButtonMain = styled.div.withConfig<{ iconSize?: number }>({
  componentId: 'BlogSocialButton_SocialButton',
} as any)`
  display: grid;
  grid-auto-flow: column;
  gap: 8px;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    transform: scale(1.05);
  }
  .icon {
    font-size: ${(p) => p?.iconSize || 20}px;
    line-height: 0;
  }
  .text {
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
  }
`;

export const SocialButton = ({ ...rest }) => {
  return <SocialButtonMain {...rest} />;
};

export const BlogSocialButton = (props: BlogSocialButtonProps) => {
  const { pageData, seoData, actions, align, showText, extraActionProps, ...rest } = props;
  const uniqueActions = uniq(actions);
  const { goBack } = useHistoryRouter(false);

  const pageId = seoData?.id || seoData?.data?.id;

  if (pageId) {
    return (
      <Main className={cl('social-buttons', align, { 'hide-text': !showText })} {...rest}>
        {uniqueActions.map((actionName, actionNameIndex) => {
          switch (actionName) {
            case 'back': {
              return (
                <SocialButton
                  key={`back${actionNameIndex}`}
                  popoverText={extraActionProps?.tooltip?.back}
                  onClick={() => {
                    goBack(extraActionProps?.defaultBackLink);
                  }}
                  className="social-button btn-back"
                  iconSize={extraActionProps?.iconSize}
                >
                  <div className="icon">
                    <IconInterfaceEssentialBack />
                  </div>
                </SocialButton>
              );
            }
            case 'share':
            case 'facebook':
              return (
                <DolFacebookShareButton
                  pageId={pageId}
                  className="social-button"
                  key={`facebook-share${actionName}${actionNameIndex}`}
                  url={seoData?.url}
                >
                  <SocialButton
                    popoverText={extraActionProps?.tooltip?.facebook}
                    iconSize={extraActionProps?.iconSize}
                    className="btn-facebook"
                  >
                    <div className="icon">
                      <IconBrandsFacebook />
                    </div>
                    <div className="text">Share</div>
                  </SocialButton>
                </DolFacebookShareButton>
              );
            case 'clap':
              // return (
              //   <PageClapButton
              //     size={extraActionProps?.iconSize || 20}
              //     key="page-clap"
              //     pageId={seoData.id}
              //   />
              // );
              return null;
            case 'do-test': {
              if (!pageData.length) return null;
              const actionDoTest = pageData.find(
                (item) => item.templateTypeId === PageTypeEnum.DO_TEST
              );
              return (
                <Link
                  target="_blank"
                  key={`do-test${actionNameIndex}`}
                  href={getLandingUrlFromPath(actionDoTest?.url)}
                >
                  <Button.Primary iconLeft={<IconMultimediaPlayButtonO />}>Làm bài</Button.Primary>
                </Link>
              );
            }
            case 'copy-link': {
              return (
                <CopyLinkButton key={`copy-link${actionNameIndex}`} url={seoData?.url || '/'} />
              );
            }
            default:
          }
          return null;
        })}
      </Main>
    );
  }
  return null;
};

export const BlogSocialButtonPreview = (props: BlogSocialButtonProps) => {
  const { actions, align, showText } = props;

  const uniqueActions = uniq(actions);
  return (
    <Main className={cl('social-buttons', align, { 'hide-text': !showText })}>
      {uniqueActions.map((actionName) => {
        switch (actionName) {
          case 'facebook':
            return (
              <DolFacebookShareButton
                pageId={undefined}
                className="social-button"
                key="facebook-share"
                url={undefined}
              >
                <SocialButton className="btn-facebook">
                  <div className="icon">
                    <IconBrandsFacebook />
                  </div>
                  <div className="text">Share</div>
                </SocialButton>
              </DolFacebookShareButton>
            );
          case 'clap':
            return (
              <div className="icon-clap">
                <IconClap fontSize={25} />
              </div>
            );
          default:
        }
        return null;
      })}
    </Main>
  );
};
